import React from 'react';

import { CmBox, CmFlex, CmText } from '@/components/uiParts';
import {
  FIELD_LABEL_COLOR,
  FIELD_LABEL_WIDTH,
  FIELD_SEPARATOR_COLOR,
} from '@/pages/externals/mos-pos-resend/service';

type Props = {
  label: string;
  /** バッジや強調表示の金額も載せるため ReactNode を受け取る */
  value: React.ReactNode;
  width?: string;
};

/**
 * SCR002 / SCR003 の「ラベル + 値」1行分 (テンプレートの .field)。
 *
 * NOTE 共通の CmLabelAndText はほぼ同じ見た目だが、値の幅を
 *      `calc(100% - ${width}px)` と組み立てているため width='190px' のときに
 *      `calc(100% - 190pxpx)` という不正な CSS になり、幅指定が無視される。
 *      共通側を直すとメニュー管理など 8 画面に影響が出るため、本画面専用に持つ。
 */
export const DetailField: React.VFC<Props> = ({
  label,
  value,
  width = FIELD_LABEL_WIDTH,
}) => (
  <CmFlex
    alignItems="baseline"
    padding="9px 0"
    borderBottomWidth="1px"
    borderBottomStyle="dashed"
    borderBottomColor={FIELD_SEPARATOR_COLOR}
  >
    <CmText
      width={width}
      flexShrink={0}
      fontSize="12.5px"
      fontWeight="normal"
      color={FIELD_LABEL_COLOR}
    >
      {label}
    </CmText>
    <CmBox width={`calc(100% - ${width})`} fontSize="13px">
      {value}
    </CmBox>
  </CmFlex>
);
